/**
 * RichText — a prose text section. Data contract + slot schema.
 *
 * Renders a block of body copy as paragraphs (split on blank lines), optionally
 * centered. The component lives in @diality/ui; this file is the serializable
 * contract the CMS stores and the public site consumes.
 */
import { EMPTY_RICH_TEXT_DOCUMENT } from "../page";
export { EMPTY_RICH_TEXT_DOCUMENT };
export const richTextSchema = {
    componentId: "RichText",
    scalarSlots: [
        { key: "align", label: "Alignment (left / center)", type: "text" },
    ],
    mediaSlots: [],
    documentSlots: [{ key: "body", label: "Body" }],
};
//# sourceMappingURL=rich-text.js.map